export default __webpack_public_path__ + "static/media/logo_stoned_egod_B.0c62ec41.png";